module.exports = __webpack_public_path__ + "static/media/cam.84d9b446.svg";